/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AuthLoginRequest } from "../models/AuthLoginRequest";
import type { AuthLoginResponseApiRespoonse } from "../models/AuthLoginResponseApiRespoonse";
import type { AuthLogoutRequest } from "../models/AuthLogoutRequest";
import type { AuthLogoutResponseApiRespoonse } from "../models/AuthLogoutResponseApiRespoonse";
import type { AuthMeRequest } from "../models/AuthMeRequest";
import type { AuthMeResponseApiRespoonse } from "../models/AuthMeResponseApiRespoonse";
import type { AuthUpdatePasswordRequest } from "../models/AuthUpdatePasswordRequest";
import type { AuthUpdatePasswordResponseApiRespoonse } from "../models/AuthUpdatePasswordResponseApiRespoonse";
import type { AuthUpdateProfileRequest } from "../models/AuthUpdateProfileRequest";
import type { AuthUpdateProfileResponseApiRespoonse } from "../models/AuthUpdateProfileResponseApiRespoonse";

import type { CancelablePromise } from "../core/CancelablePromise";
import { OpenAPI } from "../core/OpenAPI";
import { request as __request } from "../core/request";

export class AuthService {
  /**
   * ログイン
   * @param requestBody
   * @returns AuthLoginResponseApiRespoonse 正常レスポンス
   * @throws ApiError
   */
  public static authLogin(
    requestBody: AuthLoginRequest
  ): CancelablePromise<AuthLoginResponseApiRespoonse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/auth/login",
      body: requestBody,
      mediaType: "applicatin/json",
      errors: {
        400: `Fail to process.`,
        401: `fail to authentication`,
        419: `token mismatch`,
      },
    });
  }

  /**
   * ログアウト
   * @param requestBody
   * @returns AuthLogoutResponseApiRespoonse 正常レスポンス
   * @throws ApiError
   */
  public static logout(
    requestBody: AuthLogoutRequest
  ): CancelablePromise<AuthLogoutResponseApiRespoonse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/logout",
      body: requestBody,
      mediaType: "applicatin/json",
      errors: {
        400: `Fail to process.`,
        401: `fail to authentication`,
        419: `token mismatch`,
      },
    });
  }

  /**
   * ログイン情報取得
   * この API を利用するには、ログイン済みである必要があります。
   * @param requestBody
   * @returns AuthMeResponseApiRespoonse 正常レスポンス
   * @throws ApiError
   */
  public static me(
    requestBody: AuthMeRequest
  ): CancelablePromise<AuthMeResponseApiRespoonse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/me",
      body: requestBody,
      mediaType: "applicatin/json",
      errors: {
        400: `Fail to process.`,
        401: `fail to authentication`,
        419: `token mismatch`,
      },
    });
  }

  /**
   * ユーザ情報更新
   * @param requestBody
   * @returns AuthUpdateProfileResponseApiRespoonse 正常レスポンス
   * @throws ApiError
   */
  public static update(
    requestBody: AuthUpdateProfileRequest
  ): CancelablePromise<AuthUpdateProfileResponseApiRespoonse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/update",
      body: requestBody,
      mediaType: "applicatin/json",
      errors: {
        400: `Fail to process.`,
        401: `fail to authentication`,
        419: `token mismatch`,
      },
    });
  }

  /**
   * パスワード更新
   * @param requestBody
   * @returns AuthUpdatePasswordResponseApiRespoonse 正常レスポンス
   * @throws ApiError
   */
  public static updatePassword(
    requestBody: AuthUpdatePasswordRequest
  ): CancelablePromise<AuthUpdatePasswordResponseApiRespoonse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/update-password",
      body: requestBody,
      mediaType: "applicatin/json",
      errors: {
        400: `Fail to process.`,
        401: `fail to authentication`,
        419: `token mismatch`,
      },
    });
  }
}
